"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _InteractiveChatMessages = require("../InteractiveChatMessages.styled");
var Message = exports.Message = function Message(_ref) {
  var message = _ref.message;
  var initials = message.senderName.split(' ');
  initials = "".concat(initials[0][0]).concat(initials[1] ? initials[1][0] : '');
  return _react["default"].createElement(_InteractiveChatMessages.MessageWrapper, null, _react["default"].createElement(_InteractiveChatMessages.Image, {
    $bgColor: message.avatarColor
  }, _react["default"].createElement("label", null, initials)), _react["default"].createElement(_InteractiveChatMessages.ContentArea, null, _react["default"].createElement(_InteractiveChatMessages.SenderName, null, message.senderName), _react["default"].createElement(_InteractiveChatMessages.MessageText, null, message.message)));
};
Message.propTypes = {
  message: (0, _propTypes.shape)({
    _id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),
    senderName: _propTypes.string,
    message: _propTypes.string,
    avatarColor: _propTypes.string
  })
};